export enum OrderDispatch {
  DRAFT = 'draft',
  FLEET = 'fleet',
  GLOBAL = 'global',
  FLEET_GLOBAL = 'fleet-global',
}
